import {useMemo} from 'react';
import {splitOutXml, INCLUDED_EXTENSIONS} from './whiteListToolboxXML';

/**
 * 自定义 hook：根据传入的 xml 返回扩展的可见性对象数组
 * @param {string} xml - 工具箱 XML 字符串
 * @returns {Array} - 扩展可见性对象数组，包含扩展 ID 和是否可见
 */
export const useCategoryVisibility = xml => {
    const visibleExtensions = useMemo(() => {
        if (!xml) {
            return INCLUDED_EXTENSIONS.map(extensionId => ({
                id: extensionId,
                visible: true
            }));
        }
        const {extXmlObj} = splitOutXml(xml);
        const checkCategoryVisible = cid => {
            if (extXmlObj.hasOwnProperty(cid)) {
                // 配了该拓展下有某些积木块显示
                if (extXmlObj[cid].includes('</block>')) {
                    return true;
                }
                // 没配block说明是全部选了不显示任务一个块
                return false;
            }
            // 没配置的拓展category默认展示
            if (!extXmlObj.hasOwnProperty(cid)) {
                return true;
            }
            return true;
        };
        try {

            // 将扩展对象转换为可见性数组
            return INCLUDED_EXTENSIONS.map(extensionId => ({
                id: extensionId,
                visible: checkCategoryVisible(extensionId)
            }));
        } catch (error) {
            console.error('解析 XML 时出错:', error);
            return [];
        }
    }, [xml]);

    return visibleExtensions;
};
